'use strict';

const _ = require('lodash');

/**
 * Create an error message for a violated exclusion (read: rule).
 * The format for this message was lifted directly from Configuration URL so as to ensure functional parity.
 * @param {object} violatedExclusion The violated exclusion (read: rule).
 * @returns {string} A message describing the rule violation.
 */
function createViolatedExclusionMessage(violatedExclusion) {
    return `Rule ${violatedExclusion.name} was violated.`;
}

/**
 * Create an error message for a missing attribute.
 * The format for this message was lifted directly from Configuration URL so as to ensure functional parity.
 * @param {object} missingAttribute The missing attribute.
 * @returns {string} A message describing the missing attribute.
 */
function createMissingAttributeMessage(missingAttribute) {
    return `Attribute ${missingAttribute.attributeKey} is missing.`;
}

/**
 * Creates human-readable error messages for the attribute resolver.
 * These error messages will be emitted to the caller but should not be relied upon for programmatic use.
 */
module.exports = class ErrorMessageFactory {

    /**
     * Creates error messages from a validation result.
     * @param {object} validationResult A validation result describing validation errors.
     * @returns {array} A set of error message strings created from the validation result details.
     */
    static create(validationResult) {
        const errorMessages = [];

        const missingAttributeMessages = _.map(validationResult.missingAttributes, createMissingAttributeMessage);
        errorMessages.push(...missingAttributeMessages);

        const violatedSelectionMessages = _.map(validationResult.violatedSelections, (violatedSelection) => violatedSelection.message);
        errorMessages.push(...violatedSelectionMessages);

        const violatedExclusionMessages = _.map(validationResult.violatedExclusions, createViolatedExclusionMessage);
        errorMessages.push(...violatedExclusionMessages);

        return errorMessages;
    }
};
